/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Polygon } from "./Polygon";
import {
  PolygonFromJSON,
  PolygonFromJSONTyped,
  PolygonToJSON,
  PolygonToJSONTyped,
} from "./Polygon";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedRasterEdit
 */
export interface PatchedRasterEdit {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  raster?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * Absolute or relative height (in meters)  to use for the polygon
   */
  value?: number;
  /**
   *
   */
  polygon?: Polygon;
  /**
   * Process the value as a relative height, default is absolute
   */
  relative?: boolean;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedRasterEdit interface.
 */
export function instanceOfPatchedRasterEdit(value: object): value is PatchedRasterEdit {
  return true;
}

export function PatchedRasterEditFromJSON(json: any): PatchedRasterEdit {
  return PatchedRasterEditFromJSONTyped(json, false);
}

export function PatchedRasterEditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedRasterEdit {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    raster: json["raster"] == null ? undefined : json["raster"],
    offset: json["offset"] == null ? undefined : json["offset"],
    value: json["value"] == null ? undefined : json["value"],
    polygon: json["polygon"] == null ? undefined : PolygonFromJSON(json["polygon"]),
    relative: json["relative"] == null ? undefined : json["relative"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedRasterEditToJSON(json: any): PatchedRasterEdit {
  return PatchedRasterEditToJSONTyped(json, false);
}

export function PatchedRasterEditToJSONTyped(
  value?: Omit<PatchedRasterEdit, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    raster: value["raster"],
    offset: value["offset"],
    value: value["value"],
    polygon: PolygonToJSON(value["polygon"]),
    relative: value["relative"],
  };
}
